import React from 'react';
import { styled } from '@mui/material';
import { BasicCard } from './BasicCard';
import { Notifications } from './Notifications';

import type { DashboardSummary } from '../types';
import { OnboardProgress } from './OnboardProgress';

export function NotificationsAndPayments({
    data,
    loading,
    error,
    refresh,
    small,
}: {
    data?: DashboardSummary;
    loading: boolean;
    error: boolean;
    refresh: () => void;
    small: boolean;
}) {
    if (error || !data) return null;

    function callToAction() {
        if (loading || !data) return null;

        if (data?.has_posted_jobs) {
            return <Notifications data={data} />;
        }

        return <OnboardProgress data={data} refresh={refresh} />;
    }

    return (
        <BasicCard loading={loading} small={small}>
            <CardBody>{callToAction()}</CardBody>
        </BasicCard>
    );
}

const CardBody = styled('div')({
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
});
